import moment from 'moment';
import { Box, TableCell, TableRow } from '@mui/material';
import { VendorAccountShort } from '../../types';
import { VendorAccountTableItem, MenuOption } from './types';
// import ResendButton from '../../components/buttons/ResendButton';
import OptionsMenu from './OptionsMenu';
import { StatusChip } from '../../components/StatusChip';
import { VendorStatusMap } from '../FirmBankingView/constants';
import { VendorTypeMap } from './constants';

interface vendorAccountTableRowProps {
  data: VendorAccountShort[];
  onEditButtonClick: (accountId: number, option: MenuOption) => void;
  // onDeleteButtonClick: (accountId: number) => void;
  onResendConfirmationClick?: (accountId: number) => void;
  onRowClick: (accountId: number) => void;

}

const VendorAccountTableRow = ({
  data,
  onEditButtonClick,
  onRowClick,
  // onResendConfirmationClick,
}: vendorAccountTableRowProps) => {
  const formattedTableData: VendorAccountTableItem[] = data.map((account) => ({
    // createdAt: moment(account.createdAt).format('M/D/YYYY'),
    updatedAt: moment(account.updatedAt).format('M/D/YYYY'),
    id: account.id,
    name: account.name,
    vendorType: account.vendorType,
    defaultPaymentMethod: account.defaultPaymentMethod,
    status: account.vendorStatus,
    isVendorConfirmationRequired: account.isVendorConfirmationRequired,
  }));

  return (
    <>
      {formattedTableData.map((tableItem) => (
        <TableRow key={tableItem.id} sx={{ width: '100%', '&:hover': { cursor: 'default' } }}>
          {Object.entries(tableItem).map(([key, value], idx) => {
            if (key === 'id' || key === 'isVendorConfirmationRequired') return;
            return (
              <TableCell
                key={idx}
                onClick={() => onRowClick(tableItem.id)}
                sx={{ whiteSpace: 'normal !important', }}
              >
                {key === 'status' ? (
                  <StatusChip
                    label={VendorStatusMap[tableItem.status]?.label || tableItem.status}
                    color={VendorStatusMap[tableItem.status]?.color || 'default'}
                  />
                ) : key === 'vendorType' ? (
                  VendorTypeMap[value as string] || value
                ) : (
                  value
                )}
              </TableCell>
            );
          })}
          <TableCell 
            sx={{ whiteSpace: 'normal !important' }}
            onClick={() => onRowClick(tableItem.id)}
          >
            <Box display='flex' gap='12px' alignItems='center'>
              <OptionsMenu onClick={(option) => onEditButtonClick(tableItem.id, option)} />
              {/* {(tableItem.status === 'NEW' || tableItem.status === 'CONFIRMATION_REQUIRED_VENDOR') && tableItem.isVendorConfirmationRequired === true ?
                <ResendButton
                  onClick={() => onResendConfirmationClick && onResendConfirmationClick(tableItem.id)}
                />
                : ''
              } */}
            </Box>
          </TableCell>
        </TableRow>
      ))}
    </>
  );
};

export default VendorAccountTableRow;